export default __webpack_public_path__ + "static/media/04.dcdbc47f.jpg";